<mat-button-toggle-group [formControl]="selected" name="fontStyle" aria-label="Font Style">
    @for(button of buttons(); track $index) {
    <mat-button-toggle [value]="button.value">
        {{button.name}}
    </mat-button-toggle>
    }
</mat-button-toggle-group>
